import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import HomePage from './pages/HomePage'
import Catalogue from './pages/Catalogue'

const App = () => {
  return (
    <>
     <BrowserRouter>
       <Routes>
         <Route path="/" element={<HomePage/>}/>
         <Route path='catalogue' element={<Catalogue/>} />
       </Routes>
     </BrowserRouter>
    </>
  )
}

export default App